import { ProgressionStep } from '@domgen/dgx-fe-components/progress';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { fadeInOut } from '@common/ui-sales-components';
import { BuildConfigService, LoaderService } from '@common/util-foundation';
import { BuildConfig } from '@common/util-models';
import { NavigationLink } from '@domgen/dgx-fe-business-models';
import { FeatureConfigFacade } from '@common/data-access-feature-config';

@Component({
  selector: 'sky-app-root',
  templateUrl: './sky-app.component.html',
  styleUrls: ['./sky-app.component.scss'],
  animations: [fadeInOut],
})
export class SkyAppComponent {
  config: BuildConfig = this.buildConfigService.config;
  loading$ = this.loaderService.loading$;
  mobileJourney$ = this.featureConfigFacade.isMobileJourney$;
  steps: ProgressionStep[] = [];

  nonMobileSteps: ProgressionStep[] = [
    {
      label: 'Choose your devices',
      routerPath: '/add-device',
    },
    {
      label: 'Review your basket',
      routerPath: '/basket',
    },
    {
      label: 'Personal details',
      routerPath: '/checkout/personal-details',
    },
    {
      label: 'Payment details',
      routerPath: '/checkout/direct-debit-payment',
    },
    {
      label: 'Confirmation',
      routerPath: '/checkout/order-confirmation',
    },
  ];

  mobileSteps: ProgressionStep[] = [
    {
      label: 'Add your mobile',
      routerPath: '/add-mobile',
    },
    ...this.nonMobileSteps.slice(2), // include everything from the 3rd object (2) onwards from nonMobileSteps
  ];

  footerMoreLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'more'
  );
  footerUsefulLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'useful'
  );
  footerLegalLinks: NavigationLink[] = this.config.footer.links.filter(
    ({ section }) => section === 'legal'
  );

  constructor(
    public readonly buildConfigService: BuildConfigService,
    private readonly loaderService: LoaderService,
    public router: Router,
    private featureConfigFacade: FeatureConfigFacade
  ) {}

  hideProgressionSteps(routePath: string): boolean {
    return (
      routePath === '/' || routePath === '/quote' || routePath === '/error'
    );
  }
}
